export enum AdminInfoFormProps {
  IMAGE_ALT = 'Carbon one',
  HEADING = "Let's create your account",
  SUBHEADING = 'Already have an account?',
  SPAN_SUBHEADING = 'Login',
  HELPER_TEXT = 'Agree to ',
  HELPER_SPAN = 'terms & condition',
  CHECKBOX_NAME = 'terms',
  BUTTON_LABEL = 'Create',
  EXTENSION = '+1',
  LOCAL_STORAGE_FORM = 'signupUser',
  REQUIRED = 'Required',
  EMAIL_EXISTS = 'Email already exists. Try to Login',
  UNIQUE_EMAIL = 'unique-email',
  ENTER_VALID_EMAIL = 'Enter a valid email.',
  ENTER_VALID_PH_NUMBER = 'Enter a valid phone number',
  PASSWORD_CRITERIA = 'Password must be at least 8 characters long',
  PASSWORD_CRITERIA_2 = 'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character',
  CREATE_PASSWORD = 'createPassword',
  CONFIRM_PASSWORD = 'Passwords must match',
}
